// Company toggle notified by SMS
document.addEventListener('DOMContentLoaded', () => {
  function toggleNotifiedBySMSForEachUser() {
    const users = document.querySelectorAll('.users > .inputs')

    users.forEach((user) => {
      const notifiedBySMSHint = user.querySelector('.notified_by_sms .inline-hints')
      const notifiedBySMSInput = user.querySelector('.notified_by_sms input[type="checkbox"]')
      const userPhoneNumber = user.querySelector('.user_phone')

      if (!notifiedBySMSHint || !notifiedBySMSInput || !userPhoneNumber) return

      let userPhoneNumberValue = userPhoneNumber.value

      function toggleNotifiedBySMSInput() {
        if (userPhoneNumberValue !== '') {
          notifiedBySMSInput.disabled = false
          if (notifiedBySMSHint) notifiedBySMSHint.style.display = 'none'
        } else {
          notifiedBySMSInput.disabled = true
          notifiedBySMSInput.checked = false
          if (notifiedBySMSHint) notifiedBySMSHint.style.display = ''
        }
      }

      toggleNotifiedBySMSInput()

      userPhoneNumber.addEventListener('keyup', (e) => {
        userPhoneNumberValue = e.target.value
        toggleNotifiedBySMSInput()
      })
    })
  }

  toggleNotifiedBySMSForEachUser()

  const addContactButton = document.querySelector('.users > .has_many_add')
  if (addContactButton) {
    addContactButton.addEventListener('click', () => {
      setTimeout(toggleNotifiedBySMSForEachUser, 200)
    })
  }
})

